import React from "react";
import {
  Typography,
  Grid,
  Container,
  Card,
  CardActionArea,
} from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import Icon from "../../components/Icon";
import { useNavigate } from "react-router-dom";
const useStyles = makeStyles(() => ({
  carStyle: {
    border: "1px solid #A5A5A5 !important",
  },
  cardTitle: {
    fontSize: "25px !important",
    fontStyle: "Poppins  !important",
    lineHeight: "37.5px  !important",
    marginTop: "20px !important",
  },
}));
export default function FPOProfileMain() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const buttons = [
    {
      label: t("Directors and CEO"),
      type: "directors",
      route: "/fpo/members",
    },
    {
      label: t("Organization Basic Data"),
      type: "organization",
      route: "/fpo/data",
    },
    {
      label: t("Financials"),
      type: "financials",
      route: "/fpo/financials",
    },
    {
      label: t("Documents"),
      type: "documents",
      route: "/fpo/documents-list",
    },
  ];
  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
          {buttons.map((button, index) => (
            <Grid
              item
              xs={12}
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                variant="outlined"
                style={{ width: "100%", height: 162 }}
                className={classes.carStyle}
              >
                <CardActionArea
                  onClick={() => navigate(button.route)}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon type={button.type} />
                  <div>
                    <Typography className={classes.cardTitle}>
                      {button.label}
                    </Typography>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}
